module.exports = __webpack_public_path__ + "img/f16be62.png";